import axios from "@/services/axios.config";
import { useQuery } from "@tanstack/react-query";

type ResponseDataType = ReviewerDecisions[];

export type ReviewerDecisions = {
	methodologyRoundId: number;
	roundNumber: number;
	roundStatus: string;
	roundStartAt: string;
	roundEndAt: string;
	roundSummary: RoundSummary;
	reviewerDetail: ReviewerDetail[];
};

export type RoundSummary = {
	totalReviewer: number;
	totalApproved: number;
	totalRejected: number;
	totalFeedbackGiven: number;
	totalExpired: number;
	totalEffectiveReviewer: number;
	nonVotingReviewer: number;
};

export type ReviewerDetail = {
	name?: string;
	role: string;
	organization?: string;
	reviewerUserId: number;
	email?: string;
} & ReviewerTypeData;

type ReviewerTypeData = VotingReviewer | NonVotingReviewer;

type VotingReviewer = {
	nonVoting: true;
};
type NonVotingReviewer = {
	nonVoting: false;
	decision: "FEEDBACK_GIVEN" | "APPROVED" | "REJECTED" | "EXPIRED";
};

const getReviewerDecisions = async ({ methodologyId, roundId }: { methodologyId: number; roundId: number }) =>
	axios
		.get<APIResponse<ResponseDataType>>(
			`/methodology/reviewer-decisions?methodologyId=${methodologyId}&methodologyRoundId=${roundId}`,
		)
		.then((res) => res.data.data)
		.catch((err) => Promise.reject((err.response.data as APIResponse).msg));

export default function useReviewerDecisions({
	methodologyId,
	roundId,
}: Partial<Parameters<typeof getReviewerDecisions>[0]>) {
	return useQuery({
		queryKey: ["reviewDecisions", methodologyId, roundId],
		enabled: !!methodologyId || !!roundId,
		queryFn: () => getReviewerDecisions({ methodologyId: methodologyId!, roundId: roundId! }),
		retry: 0,
	});
}
